import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

// Incidents popup
export const incidentsPopupWrapper = css`
  position: relative;
  width: 300px;
  height: 400px;
  border-radius: 5px;
  box-shadow: 2px 2px 10px 0 ${colors.custom.gray20};
  border: solid 1px ${colors.gray.light};
  background-color: ${colors.white};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const incidentsPopup = css`
  height: 100%;

  &.hasIncidents {
    overflow-y: scroll;
  }
`;

export const incidentsPopupHeader = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 20px 10px;
`;

export const titleHeader = css`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;

export const incidentsList = css`
  display: flex;
  flex-direction: column;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const divider = css`
  && {
    width: calc(100% - 40px);
    margin: 0 auto;
  }
`;

export const exportButton = css`
  && {
    min-width: 120px;
  }
`;

export const placeholderOrLoading = css`
  height: calc(100% - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const placeholder = css`
  margin: 0;
`;

export const backToTopButton = css`
  && {
    position: absolute;
    bottom: 20px;
    right: 20px;
    height: 32px;
    width: 32px;
  }
`;

export const listEnd = css`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
`;
